/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface TaskItemAreaDataDto
 */
export interface TaskItemAreaDataDto {
    /**
     * 
     * @type {string}
     * @memberof TaskItemAreaDataDto
     */
    $type?: TaskItemAreaDataDtoTypeEnum;
}


/**
 * @export
 */
export const TaskItemAreaDataDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoTaskItemAreaDataDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.TaskItemAreaDataDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TaskItemAreaDataDtoTypeEnum = typeof TaskItemAreaDataDtoTypeEnum[keyof typeof TaskItemAreaDataDtoTypeEnum];



/**
 * Check if a given object implements the TaskItemAreaDataDto interface.
 */
export function instanceOfTaskItemAreaDataDto(value?: unknown): value is TaskItemAreaDataDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TaskItemAreaDataDtoTypeEnum)[0];
}

export function TaskItemAreaDataDtoFromJSON(json: any): TaskItemAreaDataDto {
    return TaskItemAreaDataDtoFromJSONTyped(json, false);
}

export function TaskItemAreaDataDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskItemAreaDataDto {
    if (json == null) {
        return json;
    }
    return {
        
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function TaskItemAreaDataDtoToJSON(value?: TaskItemAreaDataDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        '$type': value['$type'],
    });
}

